import React from 'react';
import TabContainer from '../../components/TabContainer';
import TedarikcilerPage from '../tedarikci/TedarikcilerPage';
import FiyatTakipPage from '../tedarikci/FiyatTakipPage';
import TedarikciKarnesiPage from '../tedarikci/TedarikciKarnesiPage';

const TedarikciPage = () => {
  const tabs = [
    { id: 'tedarikciler', label: 'Tedarikçiler', icon: '🏭', component: <TedarikcilerPage /> },
    { id: 'fiyat-takibi', label: 'Fiyat Takibi', icon: '💰', component: <FiyatTakipPage /> },
    { id: 'tedarikci-karnesi', label: 'Tedarikçi Karnesi', icon: '📊', component: <TedarikciKarnesiPage /> },
  ];
  return <TabContainer title="Tedarikçiler" tabs={tabs} defaultTab="tedarikciler" />;
};

export default TedarikciPage;
